import { formatEventDate } from 'services/datalayer/utils';
import { PageEventFragment } from 'types/api/dato-operations.types';
import { AccountTicketFragment } from 'types/api/tickets.types';

export const mapAccountTicketToDataLayer = (
  item: AccountTicketFragment,
  event: PageEventFragment,
  idx: number,
) => ({
  itemId: item.id,
  itemName: item.name?.['en'] ?? '',
  itemCategory: event.slug,
  itemCategory2: formatEventDate(event.startDatetime),
  itemBrand: '',
  itemListName: 'Ticket event detail',
  index: idx,
  discount: 0,
  price: 0,
  quantity: 1,
});
